import FolderIcon from '@src/components/icons/folder'
import { StatElementProps } from '../ProfileStatistics'
import { Heading4, Heading5, Progress, ProgressBar, StatItemHeading, StatItemWrapper } from './StatItem.styled'

const StatItem = ({ title, value, color = '#9B51E0', hideProgress = false }: StatElementProps) => (
  <StatItemWrapper>
    <StatItemHeading>
      <FolderIcon />
      <Heading4>{title}</Heading4>
    </StatItemHeading>
    <Heading5>{value}</Heading5>
    {!hideProgress && (
      <ProgressBar>
        <Progress style={{ width: `${30}%`, backgroundColor: color }} />
      </ProgressBar>
    )}
  </StatItemWrapper>
)

export default StatItem
